"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitAdManagerYandexAction = void 0;
var tslib_1 = require("tslib");
var social_1 = require("@dp-instant/social");
var inversify_1 = require("inversify");
var InitAdManagerYandexAction = (function (_super) {
    tslib_1.__extends(InitAdManagerYandexAction, _super);
    function InitAdManagerYandexAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InitAdManagerYandexAction.prototype.execute = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var yasdk;
            return tslib_1.__generator(this, function (_a) {
                yasdk = this.page.bus.params.yasdk;
                this.ads.init(yasdk);
                return [2];
            });
        });
    };
    InitAdManagerYandexAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], InitAdManagerYandexAction);
    return InitAdManagerYandexAction;
}(social_1.InitAdManagerAction));
exports.InitAdManagerYandexAction = InitAdManagerYandexAction;
//# sourceMappingURL=InitAdManagerYandexAction.js.map